<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            class="text-center"
          >
            <canvas
              id="myChart44"
              width="30"
              height="10"
            />
          </div>
          <div
            class="text-center"
          >
            <v-row v-if="exibirMix">
              <v-col
                id="mixVendido"
                cols="12"
                sm="8"
                md="8"
                lg="8"
              >
                {{ mixVendido }} <br>
                MIX Vendido
              </v-col>
            </v-row>
          </div>
          <div
            class="text-center"
          >
            <v-row v-if="exibirMix">
              <v-col
                id="mixAtivos"
                cols="12"
                sm="8"
                md="8"
                lg="8"
              >
                {{ produtosAtivos }} <br>
                Produtos Ativos
              </v-col>
            </v-row>
          </div>
          <div
            class="text-center"
          >
            <canvas
              id="myChart45"
              width="30"
              height="8"
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Produto from '../../../../../services/analiseproduto5'
  import eventEmit from '../../core/EventoEmit'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  export default {
    name: 'ShowMixComercilizados',
    emits: [],
    components: {},
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      exibirMix: false,
      mixVendido: 0,
      produtosAtivos: 0,
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      produtos: [],
      cidades: [],
      linhasProducao: [],
      myChartMixComercializados: {},
      myChartPorcentagemComercializadas: {},
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, empresa, vendedor, area, redes, supervisor, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = empresa
        this.vendedor = vendedor
        this.area = area
        this.rede = redes
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.produtos = produtos
        this.cidades = cidades
        this.linhasProducao = linhasProducao

        this.showUpdateDadosMixComercializado()
      },

      async showUpdateDadosMixComercializado () {
        this.loading = true
        this.exibirMix = false

        this.mixVendido = 0
        this.produtosAtivos = 0

        if (this.myChartMixComercializados.data) {
          this.myChartMixComercializados.destroy()
        }

        if (this.myChartPorcentagemComercializadas.data) {
          this.myChartPorcentagemComercializadas.destroy()
        }

        await Produto.showDadosMixComercializado(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.rede, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.produtos, this.cidades, this.linhasProducao).then(resposta => {
          if (resposta.data.status) {
            this.mixVendido = resposta.data.produtoVendidos

            this.produtosAtivos = resposta.data.produtoAtivos

            this.montarGraficoMixComercializados(resposta.data.porcentagem, resposta.data.porcentagemRestante)
            this.montarGraficoPorcentagemComercializados(resposta.data.labels, resposta.data.porcentagemExibicao)
          } else if (resposta.data.msg === 'Não há dados semestral para a exibição') {
            this.mixVendido = 0

            this.produtosAtivos = 0

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirMix = true
        })
      },

      montarGraficoMixComercializados (porcentagem, porcentagemRestante) {
        const ctx = document.getElementById('myChart44').getContext('2d')

        this.myChartMixComercializados = new Chart(ctx, {
          plugins: [ChartDataLabels],
          type: 'horizontalBar',
          data: {
            labels: [''],
            datasets: [
              {
                label: 'Porcentagem',
                data: [porcentagem],
                backgroundColor: '#4780b8',
                order: 1,
                barPercentage: 0.1,
              },
              {
                label: 'Porcentagem Restante',
                data: [porcentagemRestante],
                backgroundColor: '#cadaed',
                order: 2,
                barPercentage: 0.1,
              },
            ],
          },
          options: {
            plugins: {
              datalabels: {
                display: false,
                color: function (context) {
                  if (context.dataset.label === 'Porcentagem') {
                    return '#000000'
                  } else {
                    return 'transparent'
                  }
                },
                font: {
                  size: 11,
                },
                formatter: (value) => {
                  return value.toFixed(2).toString().replace('.', ',') + '%'
                },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
              },
              xAxes: [{
                stacked: true,
                gridLines: {
                  display: false,
                },
                display: false,
              }],
              yAxes: [{
                stacked: true,
                gridLines: {
                  display: false,
                },
                color: 'transparent',
              }],
            },
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                mode: 'label',
                label: (tooltipItem, data) => {
                  var type = data.datasets[tooltipItem.datasetIndex].label
                  var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2).toString().replace('.', ',') + '%'

                  return type + ': ' + valor
                },
                title: (tooltipItem) => {
                  return 'Progresso atingimento da meta'
                },
              },
            },
          },
        })
      },

      montarGraficoPorcentagemComercializados (labels, porcentagemExibicao) {
        const ctx = document.getElementById('myChart45').getContext('2d')

        this.myChartPorcentagemComercializadas = new Chart(ctx, {
          type: 'line',
          data: {
            labels: labels,
            datasets: [
              {
                label: 'Mix',
                data: porcentagemExibicao,
                borderColor: '#4780b8',
                backgroundColor: 'transparent',
                order: 1,
                fill: false,
                tension: 0,
              },
            ],
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
              xAxes: [{
                gridLines: {
                  display: false,
                },
              }],
              yAxes: [{
                gridLines: {
                  display: false,
                },
                display: false,
              }],
            },
            low: 10,
            high: 5,
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2).toString().replace('.', ',') + '%'
                },
              },
            },
          },
        })
      },
    },
  }
</script>

<style scoped>
 @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 360px;
      margin: 0 0 0 -1rem;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width : 1381px)
  and (max-width : 1799px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width : 1800px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart44 {
      margin: -5.7rem 0 0 0 !important;
    }
  }

  @media screen
  and (min-width : 2200px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart44 {
      margin: -10.7rem 0 0 0 !important;
    }

    #mixVendido {
      margin: -10rem 0 0 10rem
    }

    #mixAtivos {
      margin: -5rem 0 0 10rem
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
